<template>
    <div id="cesiumContainer" class="full-height full-width" style="position:relative;" >
        <slot />
    </div>
</template>

<script>

import CoreMapTd from './Utils/CoreMapTd.js'
import { clearMap } from './Utils/ClearMap.js'
const Cesium = window.Cesium
export default {
    name:'SdMapTd',
    components: {},
    props:{
			viewProps:{
				type:Object,
				default:null
			}
    },
    data() {
			return {
				viewer_:null
			}
    },
		beforeDestroy(){
			clearMap(this.viewer_)
		},
    mounted() {
      this.init()  
    },
    methods: {
			init() {
				this.viewer_ = CoreMapTd.createViewer('cesiumContainer')
				this.$emit('get-viewer',this.viewer_,this)
				const center = this.viewProps?.center
				if (center) {
					this.viewer_.camera.setView({
						destination: Cesium.Cartesian3.fromDegrees(center[0] || 112.87151,  center[1] || 28.22865, center[2] || 10000),
					});
				}
				this.initComponents()
			},
			initComponents() {
				const children = this.$children
				children.forEach((child) => {
					if (child.setViewer) {
						try {
							child.setViewer(this.viewer_, this)
						} catch (error) {
							console.error(error)
						}
					}
				})
			},
    }
}

</script>

